require('./discipline.module');
require('./controllers/index.controller');
require('./controllers/news.controller');
require('./controllers/rank.controller');
require('./controllers/rank-edit.controller');